import type { FaireProductEntity } from "../../entity_types/product";

export const p_9z3d9xfixn: FaireProductEntity = {
  token: "p_9z3d9xfixn",
  type: "product",
  name: "Chickadee Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/89a9d7f906e5fd9194b53d8d1857278c4bc3933c59977889ccfb32f0aff6ed90.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/46f0db986011bf4c252139d8f09824b42d6437e6709f241fc5a1caa11683ff7e.jpeg",
    "https://cdn.faire.com/fastly/f2033d690e595ee1e8bf3d7dc5f2da13d927c494ec33d014706950c3d2d8540a.jpeg",
    "https://cdn.faire.com/fastly/05784f04589bcd10771c9e82d9b566b81193152dac18e17d97d70c6bdb73801d.jpeg",
    "https://cdn.faire.com/fastly/d9fd4bf5f8af353c2e6c47b0884fb7ae1e8a403a9e38cb2b70fca030bdd1deb6.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:06.898Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
